import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import back from "../../assets/back.svg";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    maxWidth: "45rem",
    height: "25rem",
    overflowY: "scroll",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const DistributorOrderView = ({ maxWidth = "60rem" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  console.log(location?.state);
  const data = location?.state;

  const orderDetails = [
    {
      heading: "Order ID",
      title: data?.order_id ? data?.order_id : "--",
    },
    {
      heading: "Order Date",
      title: data?.createdAt
        ? moment(data?.createdAt).format("DD MMM YYYY, HH:mm A")
        : "--",
    },
    {
      heading: "Doctor name",
      title: data?.doctor?.name ? data?.doctor?.name : "--",
    },
    {
      heading: "Pharmacy Name",
      title: data?.pharmacy_id
        ? data?.pharmacy?.pharmacy_name
        : data?.doctor?.pharmacy_type == "attach"
        ? data?.doctor?.doctorAttachPharmacy?.pharmacy?.pharmacy_name
        : data?.doctor?.pharmacy_type == "self"
        ? data?.doctor?.doctorSelfPharmacy?.pharmacy_name
        : "-",
    },
    {
      heading: "Order Value",
      title: data?.total ? `₹ ${data?.total}.00` : "--",
    },
    {
      heading: "Order Status",
      title: data?.status ? data?.status : "--",
    },
    {
      heading:
        (data?.delivery_date && data?.status == "cancelled") ||
        data?.status == "expired" ||
        data?.status == "approval_failed"
          ? ""
          : data?.status == "acknowledged" ||
            data?.status == "partially_acknowledged"
          ? "Delivered  Date"
          : "Delivery  Date",
      title: data?.delivery_date
        ? data?.status == "cancelled" ||
          data?.status == "expired" ||
          data?.status == "approval_failed"
          ? ""
          : moment(data?.delivery_date).format("DD MMM YYYY")
        : "",
    },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/distributors/onboarded",
      breadcrumb: " / distributors / onboarded distributors",
    },
    {
      path: "/distributors/onboarded/view/order-view",
      breadcrumb: data?.order_id
        ? ` / view - ${data?.order_id}`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <div className="products-page text-nowrap">
      <div className="products-main-div">
      <div className="mx-3">
        {breadcrumbs.map(({ match, breadcrumb }) => (
          <NavLink
            key={match.pathname}
            to={match.pathname}
            className="header-route-page fw_400 cursor_pointer"
          >
            <span className="fs_18">{breadcrumb}</span>
          </NavLink>
        ))}
        </div>
        <div className="products-main-list my-2 py-1">
          <div className="search-container d-flex justify-content-between ">
            <div
              className="d-flex align-items-center p-2 ms-3 m-1 mb-2"
              onClick={() => navigate(-1)}
            >
              <img src={back} alt="back_btn" />
              <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                BACK
              </span>
            </div>
          </div>
          <div className="main-view-page">
            <div className="product-details-container ms-3">
              <div className="row row-cols-5">
                {orderDetails.map((item, index) => (
                  <div
                    className="mb-2 col-10 col-6 col-md-5 col-lg-6 col-xxl"
                    key={index}
                  >
                    <h5 className="color_b0b3c7 fs_14 fw_500 m-0">
                      {item.heading}
                    </h5>
                    {item?.heading == "Order Status" ? (
                      <span
                        className={`${
                          orderStatus?.find((e) => e?.status == item?.title)
                            ?.color
                        }`}
                      >
                        {
                          orderStatus?.find((e) => e?.status == item?.title)
                            ?.value
                        }
                      </span>
                    ) : (
                      <p className={`fs_15 fn_Nunito fw_500 `}>{item.title}</p>
                    )}
                    {/* */}
                  </div>
                ))}
              </div>
            </div>
            <div className="basic-details-container">
              <p className="basic-title">Order Details</p>
            </div>
            <div className="my-4">
              <TableContainer maxWidth={maxWidth}>
                <table className="main-table">
                  <thead>
                    <tr className="table-rows">
                      <th className="table-heads" width={"10%"}>
                        Product Name
                      </th>

                      <th className="table-heads" width={"10%"}>
                        Division
                      </th>

                      <th className="table-heads" width={"5%"}>
                        ordered Qty
                      </th>

                      <th className="table-heads" width={"5%"}>
                        Supplied Qty
                      </th>

                      <th className="table-heads" width={"8%"}>
                        Current Approved Offer
                      </th>

                      <th className="table-heads" width={"8%"}>
                        Price
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.orderProducts.length > 0 &&
                      data?.orderProducts.map((ele, index) => (
                        <tr className="table-rows1" key={index}>
                          <td className="table-each-row-data">
                            {ele?.product?.product_name
                              ? ele?.product?.product_name
                              : "--"}
                          </td>
                          <td className="table-each-row-data">
                            {ele?.vendorDivision?.name
                              ? ele?.vendorDivision?.name
                              : "--"}
                          </td>
                          <td className="table-each-row-data">
                            {ele?.quantity ? ele?.quantity : "--"}
                          </td>
                          <td className="table-each-row-data">
                            {ele?.offer_qty ? ele?.offer_qty : "--"}
                          </td>
                          <td className="table-each-row-data">
                            {ele?.offer_type
                              ? `${
                                  ele?.offer_type?.charAt(0).toUpperCase() +
                                  ele?.offer_type?.slice(1)
                                } ${
                                  ele?.offer_type == "price"
                                    ? `( ₹${ele.offer} )`
                                    : ele?.offer_type == "discount"
                                    ? `( ${ele.offer}% )`
                                    : `( ${ele.offer} nos. )`
                                }`
                              : "--"}
                          </td>
                          <td className="table-each-row-data">
                            {ele.price ? `₹ ${ele.price}` : "--"}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </TableContainer>
              <TableFooter
                className="d-flex justify-content-between align-items-center px-4 table-footer"
                maxWidth={maxWidth}
              >
                <div>
                  <label className="text-white ">Total</label>
                </div>
                <div>
                  <label className="text-white fw_600 mx-5">
                    ₹ {data?.total}
                  </label>
                </div>
              </TableFooter>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorOrderView;

export const orderStatus = [
  { status: "acknowledged", value: "Acknowledged", color: "ack_status " },
  {
    status: "partially_acknowledged",
    value: "Partially Acknowledged",
    color: "color_2ad3e7 ",
  },
  { status: "fully_invoiced", value: "Invoiced", color: "text_green " },
  {
    status: "partially_invoice",
    value: "Partial Invoiced",
    color: "Medium_Purple",
  },
  { status: "pending", value: "Approval Pending", color: "Medium_Purple" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "delivered", value: "Delivered", color: "text_green" },
  {
    status: "out_for_delivery",
    value: "Out For Delivery",
    color: "text-danger",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
];
